import { useQuery } from "@tanstack/react-query";
import { Item } from "../../types/item";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import { isEmpty } from "../../helpers/string.helper";
import { FetchApiResponse } from "@coworker/apprestructured/src/shared/types/fetchApiResponseType";
import { isValidItemNumber } from "@coworker/utils/products.helper";

export async function fetchItemInfo(itemNo: string): Promise<Item | null> {
  if (!isValidItemNumber(itemNo)) {
    return null;
  }

  const url = `${TASKS_SERVICE_URL}/items/item-info?itemNo=${itemNo}`;

  const { result } = (await fetchAPI("GET", url)) as FetchApiResponse<Item>;

  return result && !isEmpty(result)
    ? ({
        ...result,
        noFormatted: formatProductIdWithDots(result?.no),
      } as Item)
    : null;
}

// Fetches Items info from Items table if found or SR
// Doesn't contain price and currency info
export const useItemInfo = (itemNo: string) => {
  return useQuery({
    queryKey: ["item", "info", itemNo],
    queryFn: async () => await fetchItemInfo(itemNo),
    enabled: !!itemNo,
    refetchOnWindowFocus: false,
    staleTime: 86400000, // cache 24 hours
  });
};
